import InternalTransfer from './InternalTransfer';

export default InternalTransfer;
